import { render, staticRenderFns } from "./form-liquidation.vue?vue&type=template&id=35a46def"
import script from "./form-liquidation.vue?vue&type=script&lang=js"
export * from "./form-liquidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports